import $ from "jquery";
import { StatsGraph } from "./stats_graph";

class OneExperienceNotice {
  public static readonly START_DATE = "2024-08-28";
  private static readonly START_WEEK = "2024-08-26";
  private static readonly START_MONTH = "2024-08-01";

  // NOTE: お知らせはidで管理しており、stagingではURL指定しにくいため、本番環境のURLを直接設定
  private static readonly NOTIFICATION_URL =
    "https://tabemiru.com/system_notifications/149";

  static getStartDate(xAxis: any): string | null {
    // This would need to reference the actual axis classes when they're implemented
    const constructor = xAxis;
    switch (true) {
      case constructor instanceof StatsGraph.DailyAxis:
        return this.START_DATE;
      case constructor instanceof StatsGraph.WeeklyAxis:
        return this.START_WEEK;
      case constructor instanceof StatsGraph.MonthlyAxis:
        return this.START_MONTH;
      default:
        return null;
    }
  }

  static append(elm: JQuery, xAxis: any): void {
    const startDate = this.getStartDate(xAxis);
    if (!this.isOneExperienceStarted(startDate)) {
      return;
    }
    elm.after(this.html);
  }

  static delete(): void {
    $("#one-experience-notice").remove();
  }

  private static isOneExperienceStarted(startDate: string | null): boolean {
    if (!startDate) {
      return false;
    }
    const targetDate = new Date(this.dateFromForm());
    const oneExperienceStartDate = new Date(startDate);
    return targetDate >= oneExperienceStartDate;
  }

  private static dateFromForm(): string {
    const dateFromForm = $("#target").val() as string;
    if (dateFromForm.length === 4) {
      return dateFromForm + "-12-31";
    }
    return dateFromForm;
  }

  private static formatDate(dateString: string): string {
    const [year, month, day] = dateString
      .split("-")
      .map((num) => parseInt(num, 10));
    return `${year}年${month}月${day}日`;
  }

  private static get html(): string {
    return `
      <p id='one-experience-notice'>
        ${this.formatDate(this.START_DATE)}以降の統計値は
        <span>
          <a href='https://cookpad.com' target='_blank'>cookpad.com</a>
        </span>
        リニューアルの影響を受けている可能性があります。
        <a href="${this.NOTIFICATION_URL}">詳細はこちら</a>。
      </p>
    `;
  }
}

export { OneExperienceNotice };
